package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_07_14_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We rejoin our heroes at 1pm in the afternoon while they drift/paddle down the cavernous river above the Malusian Darkway in 3 boats.")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Bigs, Goram, Falorn, and Tuesday")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Caper, Annette, and Dirk")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Shale and Dworlan")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After briefly slowing down, the water starts to pick up pace. Falorn hears rushing water and the cave walls begin to narrow. The dwarves boat capsizes. Caper and Annette were able to slow their boat for a while, but eventually they lose control and capsize as well. Caper flies using her magical cloak and help boat #2 & #3 with some rope. Dirk is able to flip boat #2 right side up. Dworlan is able to grab the rope but Shalin isn’t able. Tuesday shrinks the dwarves so they are easier to tow. Boat #1 is trying to slow down still. Boat #2 & #3 crew are trying to climb into boat #2 (which Dirk just flipped). Dworlin and Shale now in boat #2. Annette sees a disturbance to the north. Something that causes dread. Our heroes see a whirlpool open up in the water to the northwest. Grasping tendrils grab our heroes, knocking them prone.")
    }
}
